var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"backtop"},[_c('img',{attrs:{"src":require("@/assets/images/back_bai.png"),"alt":""},on:{"click":_vm.back}}),_c('span',[_vm._v(_vm._s(_vm.title))]),_vm._t("rightBtn")],2)}
var staticRenderFns = []

export { render, staticRenderFns }